module.exports = __webpack_public_path__ + "img/hr-stone-path-2.93f1f010.png";